<nz-spin [nzSpinning]="isSaving$ | async">
    <div style="display: flex; flex-direction: column; gap: 2rem">
        <div class="mt-6">
            <nz-select
                class="w-full"
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Search Users"
                [ngModel]="selectedUserId"
                (ngModelChange)="watch($event)"
            >
                <nz-option
                    *ngFor="let user of allUsers"
                    [nzLabel]="user.name"
                    [nzValue]="user.id"
                ></nz-option>
            </nz-select>
        </div>

        <nz-list nzBordered nzHeader="Watchers">
            <ng-container *ngFor="let watcher of watchers">
                <nz-list-item>
                    <nz-list-item-meta
                        class="text-xs"
                        [nzDescription]="watcher.email"
                    >
                        <nz-list-item-meta-title>
                            <div class="flex gap-3 items-baseline">
                                <div class="text-lg">
                                    {{ watcher.name | titlecase }}
                                </div>
                                <div>
                                    <nz-tag
                                        *ngFor="let role of watcher.roles"
                                        [nzColor]="'cyan'"
                                        class="text-xs font-light"
                                        >{{ role | lowercase }}</nz-tag
                                    >
                                </div>
                            </div>
                        </nz-list-item-meta-title>
                    </nz-list-item-meta>

                    <ul nz-list-item-actions>
                        <nz-list-item-action>
                            <button
                                (click)="unWatch(watcher.id)"
                                nz-button
                                nzType="dashed"
                            >
                                <span nz-icon nzType="eye-invisible"></span>
                                Remove
                            </button>
                        </nz-list-item-action>
                    </ul>
                </nz-list-item>
            </ng-container>
        </nz-list>
    </div>
</nz-spin>
